import React from 'react';

/**
 * Decided 2 Oct 2026: a large "Order #", "Booking #", "Subscription #" or "Submission #" title with the
 * badges inline and the date beneath. No page name and no amount: both are in the Payment block.
 */
const OrderPageHeader = ({ title, badges, date, children }) => (
  <div className="flex justify-between w-full">
    <div className="space-y-1">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
        <h1 className="text-lg font-semibold leading-tight text-gray-900 dark:text-foreground">
          {title}
        </h1>
        <div className="flex items-center gap-x-2">{badges}</div>
      </div>
      {date ? <div className="text-sm text-gray-500 dark:text-muted-foreground">{date}</div> : null}
    </div>
    {children ? <div>{children}</div> : null}
  </div>
);

export default OrderPageHeader;
